<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-user text-blue" style="margin-right: 5px;"></i>团队组员统计</span>
      <i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="expand-icon" @click="toggleExpand"></i>
    </div>

    <div v-show="isExpanded" v-loading="loading" class="table-container">
      <div class="filter-bar">
        <span class="filter-label">统计月份：</span>
        <el-date-picker
          v-model="selectedMonth"
          type="month"
          placeholder="选择月份"
          size="small"
          value-format="yyyy-MM"
          @change="handleMonthChange"
          style="width: 150px;">
        </el-date-picker>
      </div>
      <el-table :data="memberList" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="60" align="center" fixed="left"></el-table-column>
        <el-table-column prop="name" label="组员姓名" min-width="120" fixed="left"></el-table-column>
        <el-table-column prop="target_count" label="目标数" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.target_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="traffic_count" label="流量数" width="100" align="center">
          <template slot-scope="scope">
            <span style="color: #409EFF;">{{ scope.row.traffic_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deal_count" label="成交数" width="100" align="center">
          <template slot-scope="scope">
            <span style="color: #67C23A;">{{ scope.row.deal_count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deal_amount" label="成交金额" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: bold;">¥{{ scope.row.deal_amount.toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="refund_amount" label="退款金额" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #F56C6C;">-¥{{ (scope.row.refund_amount || 0).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="收款金额" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #67C23A;">¥{{ (scope.row.totalAmount || 0).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="renewAmount" label="续签金额" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #909399;">¥{{ (scope.row.renewAmount || 0).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="commissionAmount" label="提成金额" width="120" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                成交提成：¥{{ (scope.row.dealCommission || 0).toLocaleString() }}<br/>
                续签提成：¥{{ (scope.row.renewCommission || 0).toLocaleString() }}
              </div>
              <span style="color: #667eea;">¥{{ (scope.row.commissionAmount || 0).toLocaleString() }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="完成率" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getCompletionRateType(scope.row)" size="small">
              {{ getCompletionRate(scope.row) }}%
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="memberList.length === 0" class="empty-text">
        暂无数据
      </div>
    </div>
  </el-card>
</template>

<script>
import { renewCommissionRate } from '@/utility/staticData'

export default {
  name: 'MemberStatistics',
  props: {
    url: {
      type: String,
      default: 'zhaoshang/zhuguan/memberStatistics'
    },
    employeeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isExpanded: true,
      loading: false,
      memberList: [],
      selectedMonth: ''
    }
  },
  created () {
    this.initSelectedMonth()
    // this.fetchData()
  },
  watch: {
    employeeId: {
      handler () {
        if (this.employeeId) {
          this.fetchData()
        }
      },
      immediate: true
    }
  },
  methods: {
    initSelectedMonth () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      this.selectedMonth = `${year}-${month}`
    },
    toggleExpand () {
      this.isExpanded = !this.isExpanded
    },
    handleMonthChange () {
      this.fetchData()
    },
    async fetchData () {
      this.loading = true
      try {
        const params = {}
        if (this.selectedMonth) {
          const [year, month] = this.selectedMonth.split('-')
          params.year = parseInt(year)
          params.month = parseInt(month)
        }
        if (this.employeeId) {
          params.employeeId = this.employeeId
        }

        const { data: res } = await this.$http.get(this.url, { params })

        if (res.meta.status === 200) {
          this.memberList = res.data.members || []
        } else {
          this.$message.error(res.meta.msg)
        }

        // 获取团队提成数据
        try {
          const commissionParams = { type: 'month' }
          if (this.selectedMonth) {
            const [year, month] = this.selectedMonth.split('-')
            commissionParams.year = parseInt(year)
            commissionParams.month = parseInt(month)
          }
          const commissionRes = await this.$http.get('zhaoshang/performance/commission/team', { params: commissionParams })
          if (commissionRes.data.meta.status === 200) {
            const teamCommission = commissionRes.data.data.members || []
            // 将提成数据合并到组员列表中
            this.memberList = this.memberList.map(member => {
              const commissionInfo = teamCommission.find(c => c.employeeName === member.name)
              const dealCommission = commissionInfo ? commissionInfo.commissionAmount : 0
              const renewAmount = commissionInfo ? commissionInfo.renewAmount : 0
              const renewCommission = Math.round(renewAmount * renewCommissionRate * 100) / 100
              return {
                ...member,
                totalAmount: commissionInfo ? commissionInfo.totalAmount : 0,
                renewAmount,
                dealCommission,
                renewCommission,
                commissionAmount: Math.round((dealCommission + renewCommission) * 100) / 100
              }
            })
          }
        } catch (e) {
          console.error('获取团队提成数据失败', e)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取组员统计失败')
      } finally {
        this.loading = false
      }
    },
    getCompletionRate (row) {
      if (row.target_count === 0) return 0
      return ((row.deal_count / row.target_count) * 100).toFixed(1)
    },
    getCompletionRateType (row) {
      const rate = this.getCompletionRate(row)
      if (rate >= 100) return 'success'
      if (rate >= 80) return ''
      if (rate >= 60) return 'warning'
      return 'danger'
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.clearfix {
  position: relative;
}
.expand-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  transition: all 0.3s;
}
.expand-icon:hover {
  color: #409EFF;
}
.table-container {
  padding: 10px 0;
}
.filter-bar {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.filter-label {
  font-size: 14px;
  color: #606266;
  margin-right: 10px;
}
.empty-text {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}
</style>
